module.exports = __webpack_public_path__ + "static/media/chevron-red.01e6e5ea.svg";